import { Can } from 'providers/casl'
import { onFinanceAccess } from '../features/finance'
import { onLayoutAccess } from '../features/layout'
import { onPerformanceRichPlacementProductAccess } from '../features/performance'
import { onPortalAccess } from '../features/portal'
import { onTagAccess } from '../features/tag'

export const onFinancialViewer = (can: Can) => {
  onFinanceAccess(can)
  onLayoutAccess(can)
  onPerformanceRichPlacementProductAccess(can)
  onPortalAccess(can)
  onTagAccess(can)
}
